import React, { useState } from 'react';
import './texteditmenu.css';
import {
  AssetType,
  FontFamily,
  FontStyle,
  FontWeight,
} from '../../../types/typing';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLayerGroup, faTrash } from '@fortawesome/free-solid-svg-icons';
import { Animation as AnimationIcon } from '@mui/icons-material';
interface TextEditMenuProps {
  updateTextProperties: (id: string, textProperties: any) => void;
  selectedAssetOnCanvas: { id: string; selectedAsset: AssetType };
  selectedText: any;
  onDeleteAsset: ({ id, assetType }: { id: string; assetType: any }) => void;
  onMenuClick: (menu: string) => void;
}

const TextEditMenu: React.FC<TextEditMenuProps> = ({
  updateTextProperties,
  selectedAssetOnCanvas,
  selectedText,
  onDeleteAsset,
  onMenuClick,
}) => {
  const [fontSize, setFontSize] = useState(
    selectedText?.fontProperties?.fontSize
  );
  const [selectedColor, setSelectedColor] = useState(
    selectedText?.fontProperties?.fontColor
  ); // Default color
  const [fontFamily, setFontFamily] = useState(
    selectedText?.fontProperties?.fontFamily
  );
  const [fontBold, setFontBold] = useState(
    selectedText?.fontProperties?.fontWeight === FontWeight.Bold
  );

  const [fontStyle, setFontStyle] = useState(
    selectedText?.fontProperties?.fontStyle
  );

  const handleFontChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const newFontFamily = event.target.value;
    setFontFamily(newFontFamily);
    updateTextProperties(selectedAssetOnCanvas.id, {
      fontProperties: {
        ...selectedText?.fontProperties,
        fontFamily: newFontFamily,
      },
    });
  };

  const increaseFontSize = () => {
    setFontSize((prevSize: number) => prevSize + 1);
    updateTextProperties(selectedAssetOnCanvas.id, {
      fontProperties: { ...selectedText?.fontProperties, fontSize: fontSize },
    });
  };

  const decreaseFontSize = () => {
    setFontSize((prevSize: number) => (prevSize > 1 ? prevSize - 1 : 1));
    updateTextProperties(selectedAssetOnCanvas.id, {
      fontProperties: { ...selectedText?.fontProperties, fontSize: fontSize },
    });
  };

  const toggleBold = () => {
    const curBoldValue = fontBold;
    updateTextProperties(selectedAssetOnCanvas.id, {
      fontProperties: {
        ...selectedText?.fontProperties,
        fontWeight: curBoldValue ? FontWeight.Normal : FontWeight.Bold,
      },
    });
    setFontBold((prevValue: boolean) => !prevValue);
  };

  const toggleItalic = () => {
    const curFontStyle = fontStyle;
    updateTextProperties(selectedAssetOnCanvas.id, {
      fontProperties: {
        ...selectedText?.fontProperties,
        fontStyle:
          curFontStyle === FontStyle.Italic
            ? FontStyle.Normal
            : FontStyle.Italic,
      },
    });
    setFontStyle((prevValue: string) =>
      prevValue === FontStyle.Italic ? FontStyle.Normal : FontStyle.Italic
    );
  };


  const handleColorChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const color = event.target.value;
    setSelectedColor(color);

    updateTextProperties(selectedAssetOnCanvas.id, {
      fontProperties: { ...selectedText?.fontProperties, fontColor: color },
    });
    // Logic to apply the selected color to the text
  };

  function onDelete(): void {
    onDeleteAsset({ id: selectedText.id, assetType: AssetType.TEXT });
  }

  return (
    <div className="text-edit-menu">
      <div className="menu-group">
        <select
          className="font-select"
          value={fontFamily}
          onChange={handleFontChange}
        >
          {Object.values(FontFamily).map((font) => (
            <option key={font} value={font}>
              {font}
            </option>
          ))}
        </select>
        <div className="font-size-controls">
          <button className="font-size-button" onClick={decreaseFontSize}>
            -
          </button>
          <span className="font-size-display">{fontSize}</span>
          <button className="font-size-button" onClick={increaseFontSize}>
            +
          </button>
        </div>
      </div>
      <div className="menu-group">
        <input
          type="color"
          className="text-style-button"
          value={selectedColor}
          onChange={handleColorChange}
        />
        <button
          className={`text-style-button text-style-toggle ${fontBold ? 'selected' : ''}`}
          onClick={() => toggleBold()}
        >
          Bold
        </button>
        <button
          className={`text-style-button text-style-toggle ${fontStyle === FontStyle.Italic ? 'selected' : ''}`}
          onClick={() => toggleItalic()}
        >
          Italics
        </button>
        <button
          className="text-style-button icon-menu-button"
          onClick={() => onMenuClick('layer')}
          title="Layering menu"
        >
          <FontAwesomeIcon icon={faLayerGroup} />
        </button>
        <button
          className="text-style-button-animate icon-menu-button"
          onClick={() => onMenuClick('animations')}
          title="Animation menu"
        >
          <AnimationIcon />
        </button>
        <button
          className="delete-button icon-menu-button"
          onClick={() => onDelete()}
          title="Delete selected item"
        >
          <FontAwesomeIcon icon={faTrash} />
        </button>
      </div>
    </div>
  );
};

export default TextEditMenu;
